// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MoveGroupToSpaceList__list-ff8bc2 {
  flex-grow: 1;
  overflow: auto;
}

.MoveGroupToSpaceList__list-item-febedb {
  align-items: center;
  cursor: pointer;
  display: flex;
  padding: 8px 16px;
}

.MoveGroupToSpaceList__list-item-febedb:hover,
.MoveGroupToSpaceList__list-item-febedb:focus {
  background-color: var(--base-17);
}

.MoveGroupToSpaceList__avatar-d228da {
  margin-inline-end: 12px;
}

.MoveGroupToSpaceList__name-wrapper-dee249 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  overflow: hidden;
}

.MoveGroupToSpaceList__name-a3eacf {
  color: var(--base-110);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/MoveGroupToSpacePopup/MoveGroupToSpaceList/MoveGroupToSpaceList.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;AACF;;AAEA;;EAEE,gCAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,OAAA;EACA,gBAAA;AACF;;AAEA;EACE,sBAAA;EACA,wBAAA;EACA,0CAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF","sourcesContent":[".list {\n  flex-grow: 1;\n  overflow: auto;\n}\n\n.list-item {\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  padding: 8px 16px;\n}\n\n.list-item:hover,\n.list-item:focus {\n  background-color: var(--base-17);\n}\n\n.avatar {\n  margin-inline-end: 12px;\n}\n\n.name-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex: 1;\n  overflow: hidden;\n}\n\n.name {\n  color: var(--base-110);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `MoveGroupToSpaceList__list-ff8bc2`,
	"list-item": `MoveGroupToSpaceList__list-item-febedb`,
	"listItem": `MoveGroupToSpaceList__list-item-febedb`,
	"avatar": `MoveGroupToSpaceList__avatar-d228da`,
	"name-wrapper": `MoveGroupToSpaceList__name-wrapper-dee249`,
	"nameWrapper": `MoveGroupToSpaceList__name-wrapper-dee249`,
	"name": `MoveGroupToSpaceList__name-a3eacf`
};
module.exports = ___CSS_LOADER_EXPORT___;
